import { useState } from "react";

const parseHashtags = (input: string): string[] =>
	input
		.split(",")
		.map((tag) => tag?.trim().replace(/^#/, "").replace(/\s+/g, ""))
		.filter(Boolean);

const useSocialShare = () => {
	const [blueSky, setBlueSky] = useState(false);
	const [postToX, setPostToX] = useState(false);
	const [hashtags, setHashtags] = useState("");

	const reset = () => {
		setBlueSky(false);
		setPostToX(false);
	};

	return {
		blueSky,
		setBlueSky,
		postToX,
		setPostToX,
		hashtags,
		setHashtags,
		parsedHashtags: parseHashtags(hashtags),
		reset,
	};
};

export default useSocialShare;
